import { getFileExtension } from "helper/utils";
import React from "react";
import playIcon from "../../../../assets/images/add-course/play-circle.svg";
import pdfIcon from "../../../../assets/images/add-course/pdf-icon.svg";
import quizIcon from "../../../../assets/images/add-course/quiz-icon.svg";

const RenderContent = ({ contentTitle, fileName }) => {
  return (
    <>
      {getFileExtension(fileName) === "mp4" ? (
        <>
          <div className="d-flex align-items-center">
            <img src={playIcon} alt="play icon" />
            <div>{contentTitle}</div>
          </div>
        </>
      ) : (
        <></>
      )}

      {getFileExtension(fileName) === "pdf" ? (
        <>
          <div className="d-flex align-items-center">
            <img src={pdfIcon} alt="pdf icon" />
            <div>{contentTitle}</div>
          </div>
        </>
      ) : (
        <></>
      )}
      {getFileExtension(fileName) !== "pdf" &&
      getFileExtension(fileName) !== "mp4" ? (
        <>
          <div className="d-flex align-items-center">
            <img src={quizIcon} alt="quiz icon" />
            <div>{contentTitle}</div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RenderContent;
